import { circularProgressClasses } from '@mui/material/CircularProgress';

import type { ComponentOverrides } from 'theme/theme.types';

export const CIRCULAR_PROGRESS_SIZE_PX = { small: 20, medium: 24 } as const;

export const CIRCULAR_PROGRESS_THICKNESS = 5.5;

export const MuiCircularProgress: ComponentOverrides['MuiCircularProgress'] = {
  styleOverrides: {
    determinate: {
      transition: 'none',
      [`& .${circularProgressClasses.circle}`]: { transition: 'none' },
    },
    track: ({ theme }) => ({
      color: theme.palette.grey[200],
      opacity: 1,
      '@media (forced-colors: active)': { stroke: 'GrayText' },
    }),
  },
};
